import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ReturnToSupplierHistoryAction } from './return-to-supplier-history.actions';
import {
  ReturnToSupplierHistoryListContent,
  ReturnToSupplierHistorySearchCriteria
} from '../../model/return-to-supplier-history.model';

export interface ReturnToSupplierHistoryState extends EntityState<ReturnToSupplierHistoryListContent> {
  isLoading: boolean;
  selected: ReturnToSupplierHistoryListContent[];
  criteriaObject: ReturnToSupplierHistorySearchCriteria;
  totalElements: number;
  totalPages: number;
}

export const adapter: EntityAdapter<ReturnToSupplierHistoryListContent> =
  createEntityAdapter<ReturnToSupplierHistoryListContent>({
    selectId: (model) => model.documentNo
  });

export const initialState: ReturnToSupplierHistoryState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: { page: 0, size: 20 },
  totalElements: null,
  totalPages: 20
});

export const ReturnToSupplierHistoryReducer = createReducer<ReturnToSupplierHistoryState>(
  initialState,
  on(ReturnToSupplierHistoryAction.requestList, (state) => ({ ...state, isLoading: true })),
  on(ReturnToSupplierHistoryAction.responseList, (state, { data }) => ({
    ...state,
    selected: data.content,
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    isLoading: false,
    criteriaObject: {
      ...state.criteriaObject,
      page: data.page,
      size: data.size
    }
  })),
  on(ReturnToSupplierHistoryAction.clearFilters, (state) => ({
    ...state,
    criteriaObject: { page: 0, size: 20 }
  }))
);
